module.exports = __webpack_public_path__ + "static/media/s13.85683a49.png";